var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemarkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4259_2258)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.66602 10H6.67352M9.99185 10H9.99935M13.3252 10H13.3327",
    stroke: "black",
    strokeOpacity: 0.75,
    strokeWidth: 1.52778,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99935 18.3327C14.6017 18.3327 18.3327 14.6017 18.3327 9.99935C18.3327 5.39697 14.6017 1.66602 9.99935 1.66602C5.39697 1.66602 1.66602 5.39697 1.66602 9.99935C1.66602 11.3324 1.97903 12.5923 2.53557 13.7098C2.68347 14.0067 2.73269 14.3461 2.64695 14.6665L2.15061 16.5216C1.93514 17.3268 2.67186 18.0635 3.47714 17.8481L5.33217 17.3518C5.65262 17.266 5.99202 17.3153 6.28896 17.4631C7.40632 18.0197 8.66627 18.3327 9.99935 18.3327Z",
    stroke: "black",
    strokeOpacity: 0.75,
    strokeWidth: 1.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4259_2258"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemarkIcon);
export default __webpack_public_path__ + "static/media/remark-icon.1ddeb8cbb519a73c2f833e696e4fd734.svg";
export { ForwardRef as ReactComponent };